import SvgIcons from "./SvgIcons";

const ContentIcon = ({ fill = "black", nameIcon, height, width,social, alt }) => {
  return <SvgIcons social={social} width={width} height={height} logo={nameIcon} fill={fill} alt={alt}/>;
};

export default ContentIcon;